<template>
  <div class="home-view">
    <v-col v-for="offer in allOffers" :key="offer.id" style="width: 300px;">
      <offer-card :offer="offer" />
    </v-col>
  </div>
  <!-- <v-container fluid>
    <v-dialog v-model="dialogs.addOffer" persistent fullscreen>
      <add-offer
        @close="dialogs.addOffer = !dialogs.addOffer"
        @save="dialogs.addOffer = !dialogs.addOffer"
        :key="addOfferKey"
      ></add-offer>
    </v-dialog>

    <v-dialog
      v-model="dialogs.userOffers"
      persistent
      :fullscreen="this.$vuetify.breakpoint.lgAndDown"
    >
      <user-offers
        @close="dialogs.userOffers = !dialogs.userOffers"
        @save="dialogs.userOffers = !dialogs.userOffers"
        :key="addOfferKey"
      ></user-offers>
    </v-dialog>

    <v-dialog
      v-model="dialogs.showOffer"
      :fullscreen="this.$vuetify.breakpoint.mdAndDown"
      width="600"
      height="600"
    >
      <offer :offer="offer" v-on:back="dialogs.showOffer = !dialogs.showOffer"></offer>
    </v-dialog>

    <v-dialog v-model="dialogs.categories" fullscreen>
      <categories v-on:back="dialogs.categories = !dialogs.categories"></categories>
    </v-dialog>

    <template>
      <div :class="{ toolbar: $vuetify.breakpoint.mdAndUp }">
        <v-row wrap>
          <div :class="{ 'search-area': $vuetify.breakpoint.lg }">
            <v-btn id="search-icon" text small fab @click="hideSearchIcon">
              <font-awesome-icon icon="search" />
            </v-btn>

            <v-btn text fab small @click="drawer = !drawer">
              <font-awesome-icon icon="heart" />
            </v-btn>
          </div>
          <v-row id="search">
            <v-col xs="12" sm="12" md="3" lg="3" v-show="showSearch">
              <v-autocomplete
                :items="allOffers"
                item-text="merchant.name"
                item-value="merchant.name"
                :search-input.sync="searchMerchant"
                return-object
                v-model="offer"
                hide-no-data
                class="mt-1"
                placeholder="Search"
                solo
                flat
              >
                <template v-slot:item="data">
                  <v-avatar left>
                    <v-img :src="createMerchantUrl(data.item.merchant)" />
                  </v-avatar>
                  <v-list-item-content @click="viewOffer(data)" class="pl-2">
                    {{
                    data.item.merchant.name
                    }}
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-col xs="12" sm="12" md="7" lg="7" style="margin: 0 100px;">
            <v-navigation-drawer dark v-model="drawer" app width="200" class="primary" temporary>
              <h3 class="mx-11 mt-2 pb-2 white--text">Saved offers</h3>
              <v-divider></v-divider>
              <v-list>
                <v-list-item v-for="savedOffer in items.likedOffers" :key="savedOffer"></v-list-item>
              </v-list>
            </v-navigation-drawer>
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="2" offset="3" offset-md="5">
            <v-btn text tile large class="addBtn" @click="addOfferComponent">
              <font-awesome-icon icon="plus-square" class="add-icon" />Add offer
            </v-btn>
          </v-col>
        </v-row>
      </div>

      <v-alert v-if="allOffers.length == 0" :value="true" type="error">No Offers</v-alert>

      <div class="mb-3" style="display: flex; justify-content:space-between;">
        <h3 style="font-weight: 300; color: #3F51B5;">Shop</h3>
        <v-btn text small @click="dialogs.categories = !dialogs.categories">View all</v-btn>
      </div>
      <v-divider></v-divider>

      <v-btn @click="dialogs.userOffers = !dialogs.userOffers">My offers</v-btn>
      <v-row>
        <v-col xs="12" sm="12" md="12" lg="12">
          <div class="scroll-offer">
            <div v-for="offer in allOffers" :key="offer.id" class="shop-card">
              <div>
                <v-btn
                  fab
                  small
                  @click="likeOffer"
                  color="accent"
                  style="position: relative; top: 180px; left: 300px; z-index: 10"
                  :class="[like ? 'favourite' : 'white--text']"
                >
                  <font-awesome-icon icon="heart" />
                </v-btn>
                <v-card
                  width="600"
                  flat
                  class="offer-card mx-auto grey lighten-5"
                  @click="viewOffer(offer)"
                >
                  <v-img
                    :src="createImageUrl(offer)"
                    height="50%"
                    class="white--text"
                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                  >
                    <v-card-title
                      class="card-title"
                      :class="{ 'title-small': $vuetify.breakpoint.xs }"
                    ></v-card-title>
                  </v-img>
                </v-card>
                <div style="display: flex;">
                  <span>
                    <v-img
                      width="40"
                      class="mt-3 mr-4"
                      style="border-radius: 50%;"
                      :src="createMerchantUrl(offer.merchant)"
                    />
                  </span>
                  <div>
                    <h3 class="mt-4 pa-0">{{ offer.merchant.name }}</h3>
                    <v-subheader class="pa-0">{{ offer.title }}</v-subheader>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-col>

        <v-col xs="12" sm="12" md="12" lg="12">
          <div class="scroll-offer">
            <div v-for="offer in allOffers" :key="offer.id" class="shop-card">
              <v-card width="600" height="250" class="offer-card mx-auto" @click="viewOffer(offer)">
                <v-img
                  :src="createImageUrl(offer)"
                  height="50%"
                  class="white--text"
                  gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                >
                  <div style="margin-left: 90%;">
                    <v-btn
                      text
                      fab
                      @click="likeOffer"
                      :class="[like ? 'favourite' : 'white--text']"
                    >
                      <font-awesome-icon icon="heart" />
                    </v-btn>
                  </div>
                  <v-card-title
                    class="card-title"
                    :class="{ 'title-small': $vuetify.breakpoint.xs }"
                  >
                    <h4 style="font-weight: bold;">{{ offer.title }}</h4>
                  </v-card-title>
                </v-img>

                <div
                  class="pa-3"
                  style="display:flex;justify-content:space-between;align-items:flex-end"
                >
                  <v-img
                    :src="createMerchantUrl(offer.merchant)"
                    class="ma-4"
                    width="40"
                    max-width="40"
                  ></v-img>

                  <div style="display: flex; flex-direction: column; font-size: 12px;">
                    <p>{{ offer.tagline }}</p>
                    <span class="grey--text" style="font-size: 12px;">{{ offer.merchant.name }}</span>
                  </div>
                </div>
              </v-card>
            </div>
          </div>
        </v-col>

        <v-col xs="12" sm="12" md="12" lg="12">
          <div class="mb-3" style="display: flex; justify-content:space-between;">
            <h3 style="font-weight: 300; color: #3F51B5;">Eat</h3>
            <v-btn text small @click="dialogs.categories = !dialogs.categories">View all</v-btn>
          </div>
          <v-divider></v-divider>

          <div class="scroll-offer">
            <div v-for="offer in allOffers" :key="offer.id" class="shop-card">
              <v-card width="600" height="250" class="offer-card mx-auto" @click="viewOffer(offer)">
                <v-img
                  :src="createImageUrl(offer)"
                  height="50%"
                  class="white--text"
                  gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                >
                  <div style="margin-left: 90%;">
                    <v-btn
                      text
                      fab
                      @click.stop="likeOffer"
                      :class="[like ? 'favourite' : 'white--text']"
                    >
                      <font-awesome-icon icon="heart" />
                    </v-btn>
                  </div>

                  <v-card-title
                    class="card-title"
                    :class="{ 'title-small': $vuetify.breakpoint.xs }"
                  >
                    <h4 style="font-weight: bold;">{{ offer.title }}</h4>
                  </v-card-title>
                </v-img>
                <div
                  class="pa-3"
                  style="display:flex;justify-content:space-between;align-items:flex-end"
                >
                  <v-img
                    :src="createMerchantUrl(offer.merchant)"
                    class="ma-4"
                    width="40"
                    max-width="40"
                  ></v-img>

                  <div style="display: flex; flex-direction: column; font-size: 12px;">
                    <p>{{ offer.tagline }}</p>
                    <span class="grey--text" style="font-size: 12px;">{{ offer.merchant.name }}</span>
                  </div>
                </div>
              </v-card>
            </div>
          </div>
        </v-col>

        <v-col xs="12" sm="12" md="12" lg="12">
          <div class="mb-3" style="display: flex; justify-content:space-between;">
            <h3 style="font-weight: 300; color: #3F51B5;">Do</h3>
            <v-btn text small @click="dialogs.categories = !dialogs.categories">View all</v-btn>
          </div>
          <v-divider></v-divider>

          <div class="scroll-offer">
            <div v-for="offer in allOffers" :key="offer.id" class="shop-card">
              <v-card width="600" height="250" class="offer-card mx-auto" @click="viewOffer(offer)">
                <v-img
                  :src="createImageUrl(offer)"
                  height="50%"
                  class="white--text"
                  gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                >
                  <div style="margin-left: 90%;">
                    <v-btn
                      text
                      fab
                      @click="likeOffer"
                      :class="[like ? 'favourite' : 'white--text']"
                    >
                      <font-awesome-icon icon="heart" />
                    </v-btn>
                  </div>

                  <v-card-title
                    class="card-title"
                    :class="{ 'title-small': $vuetify.breakpoint.xs }"
                  >
                    <h4 style="font-weight: bold;">{{ offer.title }}</h4>
                  </v-card-title>
                </v-img>
                <div
                  class="pa-3"
                  style="display:flex;justify-content:space-between;align-items:flex-end"
                >
                  <v-img
                    :src="createMerchantUrl(offer.merchant)"
                    class="ma-4"
                    width="40"
                    max-width="40"
                  ></v-img>

                  <div style="display: flex; flex-direction: column; font-size: 12px;">
                    <p>{{ offer.tagline }}</p>
                    <span class="grey--text" style="font-size: 12px;">{{ offer.merchant.name }}</span>
                  </div>
                </div>
              </v-card>
            </div>
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <div class="mb-3" style="display: flex; justify-content:space-between;">
            <h3 style="font-weight: 300; color: #3F51B5;">Trending</h3>
            <v-btn text small>View all</v-btn>
          </div>
          <v-divider></v-divider>
        </v-col>
        <v-col lg="12" v-for="offer in allOffers" :key="offer.id">
          <v-card width="600" height="250" class="offer-card mx-auto" @click="viewOffer(offer)">
            <v-img
              :src="createImageUrl(offer)"
              height="50%"
              class="white--text"
              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
            >
              <div style="margin-left: 90%;">
                <v-btn text fab @click="likeOffer" :class="[like ? 'favourite' : 'white--text']">
                  <font-awesome-icon icon="heart" />
                </v-btn>
              </div>

              <v-card-title class="card-title" :class="{ 'title-small': $vuetify.breakpoint.xs }">
                <h4 style="font-weight: bold;">{{ offer.title }}</h4>
              </v-card-title>
            </v-img>
            <div
              class="pa-3"
              style="display:flex;justify-content:space-between;align-items:flex-end"
            >
              <v-img
                :src="createMerchantUrl(offer.merchant)"
                class="ma-4"
                width="40"
                max-width="40"
              ></v-img>

              <div style="display: flex; flex-direction: column; font-size: 12px;">
                <p>{{ offer.tagline }}</p>
                <span class="grey--text" style="font-size: 12px;">{{ offer.merchant.name }}</span>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </v-container>-->
</template>

<script>
// Components
import addOffer from "@/components/offer/addOffer";
import offerCard from "@/components/offer/card";
import userOffers from "@/components/offer/userOffers";
import categories from "@/components/categories/categories";
import VModal from "@/components/VModal";

// Vuex
import { mapActions, mapState } from "vuex";
import { create } from "domain";

export default {
  name: "home",

  components: {
    addOffer,
    offerCard,
    userOffers,
    categories,
    VModal
  },

  data() {
    return {
      addOfferKey: 0,
      offer: null,
      expand: false,
      readonly: false,
      like: false,
      showSearch: false,
      drawer: false,
      tabs: ["Validated offers", "Pending offers", "Imported only"],

      names: ["Ben", "Steve", "Emilia", "Vicki", "Steph", "Becky", "Corey"],
      workDays: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday"
      ],

      searchMerchant: "",

      dialogs: {
        addOffer: false,
        showOffer: false,
        userOffers: false,
        categories: false
      },

      items: {
        likedOffers: []
      },

      error: null
    };
  },

  methods: {
    ...mapActions({
      getMerchants: "merchants/fetchMerchants",
      findMerchant: "merchants/searchMerchants",
      getOffers: "offers/fetchOffers"
    }),

    addOfferComponent() {
      this.addOfferKey += 1;
      this.dialogs.addOffer = !this.dialogs.addOffer;
    },

    expandOffer() {
      this.expanded = !this.expanded;
    },

    viewOffer(offer) {
      this.offer = offer;
      this.dialogs.showOffer = !this.dialogs.showOffer;
    },

    likeOffer(offer) {
      this.like = !this.like;
      //this.likedOffers.push(offer)
    },

    hideSearchIcon() {
      const search = document.getElementById("search-icon");
      this.showSearch = !this.showSearch;
      const searchBar = document.getElementById("search");
      searchBar.style.margin = "20px 0 0 -80px";
    },

    createImageUrl(offer) {
      return `https://snapsales-images.s3-eu-west-1.amazonaws.com/offer/${offer.id}_${offer.image}`;
    },

    createMerchantUrl(merchant) {
      return `https://snapsales-images.s3-eu-west-1.amazonaws.com/merchant/${merchant.id}_${merchant.logo}`;
    }
  },

  computed: {
    ...mapState({
      offers: state => state.offers,
      merchants: state => state.merchants
    }),

    allOffers() {
      return this.offers.items;
    },

    allMerchants() {
      return this.merchants.items;
    }
  },

  watch: {
    searchMerchant(val) {
      if (val) {
        this.findMerchant(val);
      } else {
        this.getMerchants();
      }
    }
  },

  mounted() {
    this.getOffers();
    this.searchMerchant = "";
  }
};
</script>

<style lang="sass" scoped>

.home-view
  width: 100%
  float: right

.toolbar
  height: 300px

.addBtn
  transition: 0.3s

  &:hover
    color: #fff
    background-color: #391c6f

  .add-icon
    margin-right: 10px

.search-area
  margin-top: 20px

.scroll-offer 
  overflow: auto
  white-space: nowrap
  width: 100%
  margin: 0 auto

  .shop-card
    display: inline-block
    margin-bottom: 5px
    margin-right: 20px
    width: 100%

.view-all
  background: purple

.card-header
  height: 50%

.title-small
  font-size: 14px

.tagline-small
  font-size: 6px

.name-small
  font-size: 12px

.favourite
  color: red
</style>
